import { bathroomExperience, bathroomPackages } from "bathroom";
import { bedroomExperience, bedroomPackages } from "bedroom";
import { buildYourOwnFunctionalPackages } from "build-your-own";
import { childrensRoomExperience, childrensRoomPackages } from "childrens-room";
import { diningExperience, diningPackages } from "dining";
import { hallwayExperience, hallwayPackages } from "hallway";
import { knobsAndHandles } from "knobsandhandles";
import { livingRoomExperience, livingRoomPackages } from "living-room";
import { outdoorExperience, outdoorPackages } from "outdoor";
import { storageOnePackages } from "storageone";
import { workspaceExperience, workspacePackages } from "workspace";

import type {
  EnvironmentSettings,
  Experience,
  ExperienceApi,
} from "@inter-ikea-space-platform/experience";

export const roomExperiences = (settings: EnvironmentSettings): Experience[] => [
  bathroomExperience(settings),
  bedroomExperience(settings),
  childrensRoomExperience(settings),
  diningExperience(settings),
  hallwayExperience(settings),
  livingRoomExperience(settings),
  workspaceExperience(settings),
  outdoorExperience(settings),
];

export const rangePackages = (settings: EnvironmentSettings): Experience[] => {
  const cutoutFeature = {
    id: "cutout-feature",
    onReady: (api: ExperienceApi) => {
      // breaks unit tests if not imported async
      import("@inter-ikea-core/core-hole-cutting-feature")
        .then(({ VisualCuttingUtilities }) => {
          VisualCuttingUtilities.addProductManagerCatalogMetadataConversion(api.core.services);
          VisualCuttingUtilities.addVisualCuttingSystem(api.core.services);
        })
        .catch(() => {});
    },
  };

  return [
    ...bathroomPackages(settings),
    ...bedroomPackages(settings),
    ...workspacePackages(settings),
    ...hallwayPackages(settings),
    ...livingRoomPackages(settings),
    ...diningPackages(settings),
    ...outdoorPackages(settings),
    ...childrensRoomPackages(settings),

    ...storageOnePackages(settings),

    // shared range package
    knobsAndHandles(),

    // shared(?) functional package
    cutoutFeature,
  ];
};

export const functionalPackages = (settings: EnvironmentSettings): Experience[] =>
  buildYourOwnFunctionalPackages(settings);
